import config from 'constants/config'
import { createSelector } from 'reselect'

export const isBusinessTravellerTripRequestApprover = createSelector(
  (state: App.State) => state.businessTraveller.currentBusinessAccount?.employee?.roles,
  (roles) => {
    const approverRoles: Array<App.BusinessTraveller.EmployeeRole> = [
      'BUSINESS_APPROVER',
      'BUSINESS_ADMIN',
      'BUSINESS_MANAGER',
    ]

    return config.businessTraveller.currentAccountMode === 'business' &&
      roles?.some(role => approverRoles.includes(role))
  },
)
